.rightColumn {
    /* border-box: 200 plus the 12px of left padding */
    width: 212px;
    padding-left: 12px;
}

.rightBlock {
    margin-bottom: 15px;
    padding: 5px 10px 20px;
    border: 1px solid #ccc;
    background: #edf3fc url(./assets/images/theme/right_back.jpg) top left repeat-x;
}

.rightBlockTitle {
    margin-bottom: 1.2em;
    font-size: 14px;
    color: #666;
}

.rightBlockContent {
    font-size: 70%;
    line-height: 120%;
    color: #666;
}

.rightBlockContent a {
    font-weight: bold;
    color: #0000ff;
}

.rightBlockContent a:hover {
    color: #ff6600;
}
